export default __webpack_public_path__ + "static/media/bnr-mob.9b608641.svg";